/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authDeleteContent.defs.js'
export { main as default } from './authDeleteContent.defs.js'
